class SwiperCarousel extends HTMLElement {
  constructor() {
    super();
    this.style.display = "block";
    // if (this.querySelector('.swiper .swiper-wrapper').childElementCount === 1) return;
    this.swiper = null;
    this._createCarousel();
  }

  get carouselConfig() {
    return this.dataset.config ? JSON.parse(this.dataset.config) : {};
  }
  get carouselInstance() {
    return this.swiper;
  }
  _createCarousel(config = null, event = null) {
    const currentConfig = this.carouselConfig;
    const _config = {
      slidesPerView: 1,
      spaceBetween: 0,
      slidesOffsetBefore: 0,
      slidesOffsetAfter: 0,
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
      pagination: {
        el: ".swiper-pagination",
        clickable: true,
        renderBullet: function (index, className) {
          console.log(className);
          console.log("index", index);
          return `<span class="${className}" data-index="${index}">${(Array(2).join("0") + (index + 1)).slice(-2)}</span>`;
        },
      },
      ...config,
      ...currentConfig,
    };
    // console.log(currentConfig)

    this.swiper = new Swiper(this.querySelector(".swiper"), { ..._config });
  }
}
customElements.define("swiper-carousel", SwiperCarousel);
